<template>
<div class="WithdrawalList bgc">
    <div class="WithdrawalList-header">
        <div class="box">
            <div class="name">提现金额（元）</div>
            <div class="value">￥{{summary.borderbalance}}</div>
        </div>
        <div class="box">
            <div class="name">冻结金额（元）</div>
            <div class="value">￥{{summary.lockmoneyorder}}</div>
        </div>
        <div class="box">
            <div class="name">可提现金额（元）</div>
            <div class="value">￥{{summary.bcashbalance}}</div>
        </div>
        <div class="btn">
            <el-button type="primary" @click="handleWithdrawal">提现</el-button>
        </div>
    </div>
    <div class="filters">
        <div class="add">
            <el-button type="success" @click="handleExport">导出</el-button>
        </div>
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd"
                                  v-model="timeSlot"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
        </el-date-picker>
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
            <el-option v-for="item in withdrawalstatusList" :key="item.code" :label="item.name"
                       :value="item.code"></el-option>
        </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="orderno" label="申请编号" min-width="180px" class-name="title"></el-table-column>
            <el-table-column prop="applytime" label="申请时间" min-width="120px" class-name="title"></el-table-column>
            <el-table-column prop="cashtypename" label="提现类型" class-name="center" min-width="120px">
                <template slot-scope="scope">{{scope.row.cashtypename}}</template>
            </el-table-column>
            <el-table-column prop="cashmoney" label="提现金额（元）" class-name="center" min-width="120px">
                <template slot-scope="scope">￥{{scope.row.cashmoney}}</template>
            </el-table-column>
            <el-table-column prop="zzfee " label="手续费（元）" class-name="center" min-width="120px">
                <template slot-scope="scope">￥{{scope.row.zzfee}}</template>
            </el-table-column>
            <el-table-column prop="cashaccountmoney" label="到账金额（元）" class-name="center" min-width="120px">
                <template slot-scope="scope">￥{{scope.row.cashaccountmoney}}</template>
            </el-table-column>
            <el-table-column prop="statusname" label="状态" class-name="center" min-width="120px">
                <template slot-scope="scope"><span :class="withdrawalstatus(scope.row.status)">{{scope.row.statusname}}</span></template>
            </el-table-column>
            <el-table-column prop="authdesp" label="备注" class-name="tr" min-width="150px" label-class-name="tr">
                <template slot-scope="scope"><div class="tr">{{scope.row.authdesp}}</div></template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {getHostCashInfo, getProviderHostCashInfo, exportHostCashInfo, exportProviderHostCashInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'WithdrawalList',
    props: ['hostroletype'],
    data() {
        return {
            param: {
                begintime: '',
                endtime: '',
                status: ''
            },
            timeSlot: null,
            withdrawalstatusList: brandBusiness.withdrawalstatus,
            page: {
                page: 1,
                pageSize: 10
            },
            summary: {
                bcashbalance: '', // 提现金
                lockmoneyorder: '', // 锁定金额
                borderbalance: '' // 可提现金额
            },
            tableData: [],
            total: 0
        }
    },
    mounted() {
        if (!this.isRefresh) {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.param = {
                    begintime: '',
                    endtime: '',
                    status: ''
                }
                this.page.page = 1
            }
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleQuery() {
            this.page.page = 1
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handleWithdrawal() {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this.$router.push({name: 'BBWithdrawal'})
            } else {
                this.$router.push({name: 'SPWithdrawal'})
            }
        },
        handleView(row) {
            this.$router.push({name: 'BBTobeSentCommissionView', query: {eventid: row.eventid, hostroletype: this.hostroletype}})
        },
        handleExport() {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._export()
            } else {
                this._export2()
            }
        },
        _export() {
            this.setLoading(true)
            exportHostCashInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '提现明细' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _export2() {
            this.setLoading(true)
            exportProviderHostCashInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '提现明细' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getHostCashInfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.datacount
                    if (this.page.page === 1) {
                        this.summary.bcashbalance = data.data.bcashbalance
                        this.summary.borderbalance = data.data.borderbalance
                        this.summary.lockmoneyorder = data.data.lockmoneyorder
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList2() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getProviderHostCashInfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.datacount
                    if (this.page.page === 1) {
                        this.summary.bcashbalance = data.data.bcashbalance
                        this.summary.borderbalance = data.data.borderbalance
                        this.summary.lockmoneyorder = data.data.lockmoneyorder
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        withdrawalstatus() {
            return function (value) {
                for (let i = 0; i < brandBusiness.withdrawalstatus.length; i++) {
                    if (value === brandBusiness.withdrawalstatus[i].code) {
                        return brandBusiness.withdrawalstatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters(['isRefresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.WithdrawalList {
    padding: 20px;
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
    .WithdrawalList-header {
        padding: 20px;
        background:  #F5F7FA ;
        display: flex;
        margin-bottom: 30px;
        .box{
            flex-grow: 1;
            height: 100px;
            flex-direction: column;
            justify-content: space-between;
            display: flex;
            font-size: 16px;
            min-width: 250px;
            .value{
                font-size: 24px;
            }
        }
        .box + .box{
            border-left: 1px solid #DCDFE6 ;
        }
        .box:nth-child(n+2) {
            align-items: center;
        }
        .box:first-child .value{
            font-size: 30px;
        }
        .btn{
            align-self: center;
        }
    }
    .el-range-editor.el-input__inner{
        width: 240px;
        margin-right: 20px;
    }
}
</style>
